/**
 * Free-follow-up settings API.
 *
 * Organisation-level rule that waives the consultation fee on a re-registration
 * within a configurable number of days of the patient's last consultation
 * charge.
 *
 * Backend:
 *   GET /api/organisation/settings/free-followup
 *   PUT /api/organisation/settings/free-followup
 */
import apiClient from './apiClient';

export const getFreeFollowupSettings = async () => {
  const res = await apiClient.get('/api/organisation/settings/free-followup');
  // { enabled, window_days, scope: 'cross_doctor' | 'same_doctor' }
  return res.data;
};

export const updateFreeFollowupSettings = async (payload) => {
  // payload: { enabled?, window_days?, scope? } — partial update.
  // scope decides which doctor's prior charge anchors the window:
  // 'cross_doctor' (any doctor) or 'same_doctor' (only the returning doctor).
  const res = await apiClient.put('/api/organisation/settings/free-followup', payload);
  return res.data;
};
